import { Image } from "lucide-react";
import React, { useMemo } from "react";

import { ImageMod } from "@src/store/slices/experienceBuilder/types";
import { ModificationListItem } from "@src/features/experienceBuilder/modifications/common/ModificationListItem";

export const ImageListItem = ({ mod }: { mod: ImageMod }) => {
  const subtitle = useSubtitle(mod);
  return (
    <ModificationListItem
      mod={mod}
      icon={<Image size={16} />}
      title={"Image modification"}
      subtitle={subtitle}
    />
  );
};

function useSubtitle(mod: ImageMod) {
  return useMemo(() => {
    if (mod.description) return mod.description;

    const parts: string[] = [];
    if (mod.imageSearchUrl) {
      parts.push(getFilename(mod.imageSearchUrl));
    }
    if (mod.src) {
      parts.push(getFilename(mod.src));
    }
    return parts.join(" \u2192 ");
  }, [mod]);
}

function getFilename(url: string) {
  return url.split("/").pop() || url;
}
